"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var issue_list_1 = require("./issue-list/issue-list");
var issue_list_factory_1 = require("./issue-list/issue-list-factory/issue-list-factory");
var angular = require("angular");
var UtilsService = /** @class */ (function () {
    function UtilsService(type) {
        var _this = this;
        this.truncatedRowCount = 4;
        this.truncatedRowCountIg = 3;
        this.truncatedRowCountImpact = 2;
        this.TITLE_LIMIT = 20;
        this.TITLE_FROM_DESC_LIMIT = 13;
        this.debounceDefault = 500;
        this.zoneColor = {
            DISCOVERY: "#FFEAF4",
            SPECIFY: "#FFFFB7",
            NAVIGATE: "#C6DCFB",
            MANAGE: "#CFFFEE"
        };
        this.zoneColorDarker = {
            DISCOVERY: "#FFD6E6",
            SPECIFY: "#FFE987",
            NAVIGATE: "#AFC8F9",
            MANAGE: "#A2FFEB" // Slightly darker green
        };
        this.issueType = {
            DESIRABILITY: {
                ID: 1,
                NAME: "desirability",
                TITLE: "desirability",
                COLOR: "#FFB6C1"
            },
            FEASIBILITY: {
                ID: 2,
                NAME: "feasibility",
                TITLE: "feasibility",
                COLOR: "#FEF3A1"
            },
            VIABILITY: {
                ID: 3,
                NAME: "viability",
                TITLE: "viability",
                COLOR: "#baeea6"
            },
            STRENGTHS: {
                ID: 4,
                NAME: "strengths",
                TITLE: "strengths",
                COLOR: "#309bd1"
            },
            WEAKNESSES: {
                ID: 5,
                NAME: "weaknesses",
                TITLE: "weaknesses",
                COLOR: "#e6a029"
            },
            OPPORTUNITIES: {
                ID: 6,
                NAME: "opportunities",
                TITLE: "opportunities",
                COLOR: "#85ad2d"
            },
            THREATS: {
                ID: 7,
                NAME: "threats",
                TITLE: "threats",
                COLOR: "#c74b40"
            },
            STICKY: {
                ID: 8,
                NAME: "sticky",
                TITLE: "sticky",
                COLOR: "#add8e6"
            },
            DEFAULT: {
                ID: 9,
                NAME: "default",
                TITLE: "default",
                COLOR: "#add8e6"
            },
            HARD_ST: {
                ID: 10,
                NAME: "hardSt",
                TITLE: "hardSt",
                COLOR: "#add8e6"
            },
            MEDIUM_ST: {
                ID: 11,
                NAME: "mediumSt",
                TITLE: "mediumSt",
                COLOR: "#add8e6"
            },
            EASY_ST: {
                ID: 12,
                NAME: "easySt",
                TITLE: "easySt",
                COLOR: "#add8e6"
            }
        };
        this.experimentStatus = {
            COMPLETED: "Completed",
            ACTIVE: "Active",
            INPLAN: "In Plan",
            BACKLOG: "Backlog",
            UNPLANNED: "Unplanned"
        };
        this.calcImpactValues = { 'default': 0, 'hardSt': 8, 'mediumSt': 5, 'easySt': 2 };
        this.setStickyHeightShort = function (id, stickyIndex, note) {
            var ctrl = _this;
            var needTruncate = false;
            var minFontSize = '11px';
            // if (!note.isHeightUpdated) {
            ctrl.onTruncateIgnorance(note, id + stickyIndex);
            note.isHeightUpdated = true;
            // }
            if (needTruncate) {
                minFontSize = '14px';
            }
            return minFontSize;
        };
        this.setStickyHeightImpact = function (id, stickyIndex, note) {
            var ctrl = _this;
            var needTruncate = false;
            var minFontSize = '11px';
            if (!note.isHeightUpdated || note.initialStyle) {
                if (note.initialStyle) {
                    note.initialStyle = false;
                }
                ctrl.onTruncateImpact(note, id + stickyIndex);
                note.isHeightUpdated = true;
            }
            if (needTruncate) {
                minFontSize = '14px';
            }
            // return minFontSize;
        };
        this.issueListFactory = new issue_list_factory_1.IssueListFactory();
        this.type = type;
        this.heightCalibration = (this.type === issue_list_1.IssueListEnum.SWOT) ? 5 : (this.type === issue_list_1.IssueListEnum.INPUT_SCREEN) ? -35 : 0;
        this.issueList = this.issueListFactory.generateIssueList(type);
    }
    UtilsService.prototype.getValues = function () {
        this.issueList.getValues();
    };
    UtilsService.prototype.toSentenceCase = function (str) {
        return str.toLowerCase().charAt(0).toUpperCase() + str.slice(1);
    };
    UtilsService.prototype.getNewSticky = function (userName) {
        var timestamp = Date.now();
        var issueId = btoa(userName + '_' + timestamp);
        return {
            _id: issueId,
            name: '',
            title: '',
            description: '',
            ignorance: 0,
            impact: 0,
            calcImpact: 0,
            score: 0,
            type: this.issueType.DEFAULT.NAME,
            color: this.issueType.DEFAULT.COLOR,
            issueType: 'Manage',
            issueColor: this.zoneColor.MANAGE,
            isDfv: false,
            abilityToLaunch: { key: "default", reason: { optimism: "", pessimism: "" } },
            abilityToLaunchBefore: { key: "default", reason: { optimism: "", pessimism: "" } },
            impactMappingList: [],
            impactMappingListBefore: [],
            experiments: [],
            startDate: null,
            updatedAt: this.updatedAt()
        };
    };
    UtilsService.prototype.getDiscoveryGrid = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "DISCOVERY"
            : ignorance >= 5 && impact < 5
                ? "SPECIFY"
                : ignorance < 5 && impact >= 5
                    ? "NAVIGATE"
                    : "MANAGE";
    };
    /**
     * Determines if the impact board should use qualitative mode based on configuration
     * and user preferences.
     *
     * @param res The response containing the quantitativeOrQualitative setting
     * @param node The node object that may contain a user preference
     * @returns An object with isQualitative flag and showToggle flag
     */
    UtilsService.prototype.determineQualitativeMode = function (res, node) {
        var isQualitative = false;
        var showToggle = false;
        // Check for both lowercase and uppercase versions of the property
        var qualitativeProperty = 'quantitativeOrQualitative' in res ? 'quantitativeOrQualitative' :
            'QuantitativeOrQualitative' in res ? 'QuantitativeOrQualitative' : null;
        if (qualitativeProperty) {
            if (res[qualitativeProperty] === 'both') {
                // For "both", check if node has a saved preference
                showToggle = true;
                if ('inavImpactType' in node) {
                    isQualitative = node['inavImpactType'] == 'Qualitative';
                }
                else {
                    // Default to Quantitative when no preference is saved
                    isQualitative = false;
                }
            }
            else {
                // For explicit settings, use the specified mode directly
                isQualitative = res[qualitativeProperty] == 'qualitative';
                showToggle = false;
            }
        }
        else {
            // Default to Quantitative if not specified
            isQualitative = false;
            showToggle = false;
        }
        return { isQualitative: isQualitative, showToggle: showToggle };
    };
    UtilsService.prototype.getTypeByDropZone = function (dropZone) {
        var type = dropZone.split("Drop").pop().toUpperCase();
        return type;
    };
    UtilsService.prototype.removeIssueByIndex = function (array, index) {
        if (index > -1) {
            array.splice(index, 1);
        }
    };
    UtilsService.prototype.updatedAt = function () {
        return new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
    };
    UtilsService.prototype.sortList = function (list, key) {
        list.sort(function (a, b) { return (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0); });
    };
    UtilsService.prototype.filterZeroImpactIgnorance = function (dataGot, isQualitative) {
        var impactToBeUsed = isQualitative ? "impact" : "calcImpact";
        return dataGot.filter(function (item) { return item[impactToBeUsed] > 0 && item.ignorance > 0; });
    };
    UtilsService.prototype.getDragElement = function (divCollection, clientY) {
        return divCollection.reduce(function (closest, child) {
            var box = child.getBoundingClientRect();
            var offset = clientY - box.top - box.height / 2;
            console.log("offset:", offset, "y:", clientY);
            if (offset < 0 && offset > closest.offset) {
                return { offset: offset, element: child };
            }
            else {
                return closest;
            }
        }, { offset: Number.NEGATIVE_INFINITY }).element;
    };
    UtilsService.prototype.discoveryGrid = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "DISCOVERY"
            : ignorance >= 5 && impact < 5
                ? "SPECIFY"
                : ignorance < 5 && impact >= 5
                    ? "NAVIGATE"
                    : "MANAGE";
    };
    UtilsService.prototype.discoveryGridSCase = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "Discovery"
            : ignorance >= 5 && impact < 5
                ? "Specify"
                : ignorance < 5 && impact >= 5
                    ? "Navigate"
                    : "Manage";
    };
    UtilsService.prototype.formatIssueData = function (item, isQualitative, fteGlobal) {
        var impactToBeUsed = isQualitative ? item.impact : item.calcImpact;
        var score = item.ignorance * impactToBeUsed;
        var isDfv = false;
        var isSwot = false;
        if (item.type == this.issueType.DESIRABILITY.NAME ||
            item.type == this.issueType.FEASIBILITY.NAME ||
            item.type == this.issueType.VIABILITY.NAME) {
            isDfv = true;
        }
        else if (item.type == this.issueType.STRENGTHS.NAME ||
            item.type == this.issueType.WEAKNESSES.NAME ||
            item.type == this.issueType.THREATS.NAME ||
            item.type == this.issueType.OPPORTUNITIES.NAME) {
            isSwot = true;
        }
        var experimentData = {};
        if (item.experimentData.length > 0) {
            experimentData = item.experimentData[0];
        }
        var impactToBeUsedBefore = isQualitative ? experimentData.impactBefore : experimentData.calcImpactBefore;
        var scoreBefore = experimentData.ignoranceBefore * impactToBeUsedBefore;
        var formattedObj = {
            _id: item._id,
            name: item.name ? item.name : item.title,
            ignorance: item.ignorance,
            impact: impactToBeUsed,
            title: item.title ? item.title : item.name.substring(0, 13),
            calcImpact: item.calcImpact,
            ignoranceBefore: 'ignoranceBefore' in experimentData ? experimentData.ignoranceBefore : 0,
            impactBefore: impactToBeUsedBefore,
            calcImpactBefore: 'calcImpactBefore' in experimentData ? experimentData.calcImpactBefore : 0,
            type: item.type,
            isDfv: isDfv,
            isSwot: isSwot,
            score: score,
            scoreBefore: scoreBefore,
            comment: 'comment' in experimentData ? experimentData.comment : '',
            cost: this.numberExistElseNull('cost', experimentData),
            costBefore: this.numberExistElseNull('costBefore', experimentData),
            resourceFte: this.numberExistElseNull('resourceFte', experimentData),
            resourceFteBefore: this.numberExistElseNull('resourceFteBefore', experimentData),
            resFte: 'resFte' in experimentData ? experimentData.resFte : null,
            resFteBefore: 'resFteBefore' in experimentData ? experimentData.resFteBefore : null,
            startDatePotential: 'startDatePotential' in experimentData ? experimentData.startDatePotential : '',
            estCompDate: 'estCompDate' in experimentData ? experimentData.estCompDate : '',
            actualCompDate: 'actualCompDate' in experimentData ? experimentData.actualCompDate : '',
            startActiveDate: 'startActiveDate' in experimentData ? experimentData.startActiveDate : '',
            totalCost: this.numberExistElseZero('totalCost', experimentData),
            totalCostBefore: this.numberExistElseZero('totalCostBefore', experimentData),
            duration: this.numberExistElseNull('duration', experimentData),
            durationBefore: this.numberExistElseNull('durationBefore', experimentData),
            expName: 'name' in experimentData ? experimentData.name : '',
            expId: '_id' in experimentData ? experimentData._id : '',
            issueColor: this.zoneColor[this.discoveryGrid(item.ignorance, impactToBeUsed).replace(/ /g, "")],
            issueColorBefore: this.zoneColor[this.discoveryGrid(experimentData.ignoranceBefore, impactToBeUsedBefore).replace(/ /g, "")],
            issueDescription: 'issueDescription' in item ? item.issueDescription : undefined,
            needToLearn: 'needToLearn' in experimentData ? experimentData.needToLearn : '',
            goingToLearn: 'goingToLearn' in experimentData ? experimentData.goingToLearn : '',
            toMeasure: 'toMeasure' in experimentData ? experimentData.toMeasure : '',
            successCriteria: 'successCriteria' in experimentData ? experimentData.successCriteria : '',
            status: 'status' in experimentData ? experimentData.status : 'Unplanned',
            inIterationPlan: 'inIterationPlan' in item ? item.inIterationPlan : false,
            startDate: 'startDate' in item ? new Date(item.startDate) : undefined,
            issueType: this.discoveryGridSCase(item.ignorance, impactToBeUsed),
            issueTypeBefore: this.discoveryGridSCase(experimentData.ignoranceBefore, impactToBeUsedBefore),
            impactMappingList: 'impactMappingList' in item ? item.impactMappingList : 'default',
            impactMappingListBefore: 'impactMappingListBefore' in experimentData ? experimentData.impactMappingListBefore : 'default',
            abilityToLaunch: 'abilityToLaunch' in item ? item.abilityToLaunch : { 'key': 'default', 'reason': { 'pessimism': '', 'optimism': '' } },
            abilityToLaunchBefore: 'abilityToLaunchBefore' in experimentData ? experimentData.abilityToLaunchBefore : { 'key': 'default', 'reason': { 'pessimism': '', 'optimism': '' } },
            isPotentialShowStopper: 'isPotentialShowStopper' in item ? item.isPotentialShowStopper : false,
            isPotentialShowStopperBefore: 'isPotentialShowStopperBefore' in experimentData ? experimentData.isPotentialShowStopperBefore : false,
            defined: 'defined' in experimentData ? experimentData.defined : 0,
            result: 'result' in experimentData ? experimentData.result : 'passed',
            readiness: {
                score: score,
                ignorance: item.ignorance,
                impact: impactToBeUsed
            }
        };
        formattedObj.defined = this.getDefined(formattedObj, fteGlobal);
        return formattedObj;
    };
    UtilsService.prototype.numberExistElseNull = function (attribute, data) {
        return attribute in data && data[attribute] !== "" ? data[attribute] : null;
    };
    UtilsService.prototype.numberExistElseZero = function (attribute, data) {
        return attribute in data && data[attribute] !== "" ? data[attribute] : 0;
    };
    UtilsService.prototype.getIssueConfigWithTitle = function (config) {
        return config.reduce(function (result, obj) {
            var _a;
            if (obj.type == 'default') {
                obj.title = 'Default';
            }
            var type = obj.type, color = obj.color, title = obj.title, subTitle = obj.subTitle;
            return __assign({}, result, (_a = {}, _a[type] = { color: color, title: title, subTitle: subTitle }, _a));
        }, {});
    };
    UtilsService.prototype.getIssueConfig = function (config) {
        return config.reduce(function (result, obj) {
            var _a;
            var type = obj.type, color = obj.color;
            return __assign({}, result, (_a = {}, _a[type] = color, _a));
        }, {});
    };
    UtilsService.prototype.returnLimitedTitle = function (d) {
        var title = "";
        if (d.title && d.title.length > 0) {
            title = d.title.slice(0, this.TITLE_LIMIT);
        }
        else {
            title = d.name.slice(0, this.TITLE_FROM_DESC_LIMIT);
        }
        return title;
    };
    UtilsService.prototype.getIssueConfigFromStorage = function (withTitle) {
        if (withTitle === void 0) { withTitle = false; }
        var ctrl = this;
        var canvasConfig = angular.fromJson(localStorage.getItem('nColCanvasConfig'));
        return {
            title: canvasConfig.Display,
            colCount: canvasConfig.ColCount ? canvasConfig.ColCount : 4,
            issueConfig: withTitle ? ctrl.getIssueConfigWithTitle(canvasConfig.Config) : ctrl.getIssueConfig(canvasConfig.Config)
        };
    };
    UtilsService.prototype.getIssueDetails = function (selectedIssue, fteGlobal) {
        var resFteGot = selectedIssue.resFte != null ? selectedIssue.resFte : {};
        if (!selectedIssue.resFte) {
            fteGlobal.map(function (fte) {
                resFteGot[fte.Key] = undefined;
            });
        }
        var currExperiment = {
            expName: selectedIssue.expName,
            expId: selectedIssue.expId,
            cost: selectedIssue.cost,
            costBefore: selectedIssue.costBefore,
            score: selectedIssue.score,
            resFte: resFteGot,
            resFteBefore: selectedIssue.resFteBefore,
            resourceFte: selectedIssue.resourceFte,
            resourceFteBefore: selectedIssue.resourceFteBefore,
            startDatePotential: selectedIssue.startDatePotential,
            totalCost: selectedIssue.totalCost,
            totalCostBefore: selectedIssue.totalCostBefore,
            duration: selectedIssue.duration,
            durationBefore: selectedIssue.durationBefore,
            ignorance: selectedIssue.ignorance,
            impact: selectedIssue.impact,
            calcImpact: selectedIssue.calcImpact,
            calcImpactBefore: selectedIssue.calcImpactBefore,
            needToLearn: selectedIssue.needToLearn,
            goingToLearn: selectedIssue.goingToLearn,
            toMeasure: selectedIssue.toMeasure,
            successCriteria: selectedIssue.successCriteria,
            status: 'status' in selectedIssue ? selectedIssue.status : undefined,
            estCompDate: 'estCompDate' in selectedIssue ? selectedIssue.estCompDate : undefined,
            actualCompDate: 'actualCompDate' in selectedIssue ? selectedIssue.actualCompDate : undefined,
            comment: 'comment' in selectedIssue ? selectedIssue.comment : '',
            startActiveDate: 'startActiveDate' in selectedIssue ? selectedIssue.startActiveDate : undefined,
            impactMappingList: 'impactMappingList' in selectedIssue ? selectedIssue.impactMappingList : 'default',
            abilityToLaunch: 'abilityToLaunch' in selectedIssue ? selectedIssue.abilityToLaunch : { 'key': 'default', 'reason': { 'pessimism': '', 'optimism': '' } },
            isPotentialShowStopper: 'isPotentialShowStopper' in selectedIssue ? selectedIssue.isPotentialShowStopper : false,
            isPotentialShowStopperBefore: 'isPotentialShowStopperBefore' in selectedIssue ? selectedIssue.isPotentialShowStopperBefore : false,
            defined: 'defined' in selectedIssue ? selectedIssue.defined : 0,
            inIterationPlan: 'inIterationPlan' in selectedIssue ? selectedIssue.inIterationPlan : false,
            ignoranceBefore: 'ignoranceBefore' in selectedIssue ? selectedIssue.ignoranceBefore : 0,
            impactBefore: 'impactBefore' in selectedIssue ? selectedIssue.impactBefore : 0,
            scoreBefore: 'scoreBefore' in selectedIssue ? selectedIssue.scoreBefore : 0,
            issueColor: 'issueColor' in selectedIssue ? selectedIssue.issueColor : '',
            issueColorBefore: 'issueColorBefore' in selectedIssue ? selectedIssue.issueColorBefore : '',
            issueTypeBefore: 'issueTypeBefore' in selectedIssue ? selectedIssue.issueTypeBefore : '',
            issueType: 'issueType' in selectedIssue ? selectedIssue.issueType : '',
            impactMappingListBefore: 'impactMappingListBefore' in selectedIssue ? selectedIssue.impactMappingListBefore : 'default',
            abilityToLaunchBefore: 'abilityToLaunchBefore' in selectedIssue ? selectedIssue.abilityToLaunchBefore : { 'key': 'default', 'reason': { 'pessimism': '', 'optimism': '' } },
            result: 'result' in selectedIssue ? selectedIssue.result : ''
        };
        return currExperiment;
    };
    UtilsService.prototype.getExpStatus = function (expStatusIndex) {
        var ctrl = this;
        var steps = [
            ctrl.experimentStatus.COMPLETED,
            ctrl.experimentStatus.ACTIVE,
            ctrl.experimentStatus.INPLAN,
            ctrl.experimentStatus.BACKLOG,
        ];
        return steps[expStatusIndex - 1];
    };
    UtilsService.prototype.updateIssueData = function (from, selectedIndex, currExperiment, fteGlobal) {
        var ctrl = this;
        var updatedIssueData = angular.copy(from);
        var experimentData = {};
        var definedScore = ctrl.getDefined(currExperiment, fteGlobal);
        experimentData['name'] = currExperiment['expName'];
        experimentData['_id'] = currExperiment['expId'];
        experimentData['cost'] = currExperiment['cost'];
        experimentData['costBefore'] = currExperiment['costBefore'];
        experimentData['ignoranceBefore'] = currExperiment['ignoranceBefore'];
        experimentData['ignorance'] = currExperiment['ignorance'];
        experimentData['impactBefore'] = currExperiment['impactBefore'];
        experimentData['impact'] = currExperiment['impact'];
        experimentData['calcImpact'] = currExperiment['calcImpact'];
        experimentData['calcImpactBefore'] = currExperiment['calcImpactBefore'];
        experimentData['scoreBefore'] = currExperiment['scoreBefore'];
        experimentData['issueColorBefore'] = currExperiment['issueColorBefore'];
        experimentData['issueColor'] = currExperiment['issueColor'];
        experimentData['impactMappingListBefore'] = currExperiment['impactMappingListBefore'];
        experimentData['impactMappingList'] = currExperiment['impactMappingList'];
        experimentData['abilityToLaunchBefore'] = currExperiment['abilityToLaunchBefore'];
        experimentData['abilityToLaunch'] = currExperiment['abilityToLaunch'];
        experimentData['isPotentialShowStopper'] = currExperiment['isPotentialShowStopper'];
        experimentData['isPotentialShowStopperBefore'] = currExperiment['isPotentialShowStopperBefore'];
        experimentData['resFte'] = currExperiment['resFte'];
        experimentData['resFteBefore'] = currExperiment['resFteBefore'];
        experimentData['resourceFte'] = currExperiment['resourceFte'];
        experimentData['resourceFteBefore'] = currExperiment['resourceFteBefore'];
        experimentData['startDatePotential'] = currExperiment['startDatePotential'];
        experimentData['totalCost'] = currExperiment['totalCost'];
        experimentData['totalCostBefore'] = currExperiment['totalCostBefore'];
        experimentData['duration'] = currExperiment['duration'];
        experimentData['durationBefore'] = currExperiment['durationBefore'];
        updatedIssueData[selectedIndex]['includeInSprint'] = currExperiment['includeInSprint'];
        updatedIssueData[selectedIndex]['issueFactor'] = currExperiment['issueFactor'];
        updatedIssueData[selectedIndex]['issueDescription'] = currExperiment['issueDescription'];
        experimentData['needToLearn'] = currExperiment['needToLearn'];
        experimentData['goingToLearn'] = currExperiment['goingToLearn'];
        experimentData['toMeasure'] = currExperiment['toMeasure'];
        experimentData['successCriteria'] = currExperiment['successCriteria'];
        experimentData['estCompDate'] = currExperiment['estCompDate'];
        experimentData['actualCompDate'] = currExperiment['actualCompDate'];
        experimentData['startActiveDate'] = currExperiment['startActiveDate'];
        experimentData['comment'] = currExperiment['comment'];
        experimentData['result'] = currExperiment['result'];
        experimentData['status'] = angular.copy(currExperiment['status']);
        if (definedScore >= 100) {
            var expStatus = ctrl.getExpStatus(currExperiment['initLearningPlanSection']);
            var excludedStatuses = [
                ctrl.experimentStatus.COMPLETED,
                ctrl.experimentStatus.INPLAN,
                ctrl.experimentStatus.ACTIVE
            ];
            var isNotExcluded = !excludedStatuses.includes(experimentData['status']);
            if (isNotExcluded) {
                experimentData['status'] = experimentData['inIterationPlan'] ? ctrl.experimentStatus.INPLAN : expStatus;
            }
        }
        else {
            experimentData['status'] = ctrl.experimentStatus.UNPLANNED;
            updatedIssueData[selectedIndex]['inIterationPlan'] = false;
        }
        experimentData['defined'] = definedScore;
        experimentData['updatedAt'] = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
        updatedIssueData[selectedIndex]['experimentData'] = [experimentData];
        return updatedIssueData;
    };
    UtilsService.prototype.getDefined = function (currExperiment, fteGlobal) {
        var ctrl = this;
        var total = 7 + Object.keys(fteGlobal).length;
        var done = 0;
        if (currExperiment.expName)
            done++;
        if (currExperiment.needToLearn)
            done++;
        if (currExperiment.goingToLearn)
            done++;
        if (currExperiment.toMeasure)
            done++;
        if (currExperiment.successCriteria)
            done++;
        if (currExperiment.cost || currExperiment.cost == 0)
            done++;
        if (currExperiment.duration || currExperiment.duration == 0)
            done++;
        if (currExperiment.resFte) {
            fteGlobal.map(function (fte) {
                if (currExperiment.resFte[fte.Key] && !isNaN(Number(currExperiment.resFte[fte.Key])))
                    done++;
            });
        }
        return Math.round((done * 100) / total);
    };
    UtilsService.prototype.checkSave = function (currExperiment, origCurrExperiment) {
        var isDirty = false;
        var currExperimentStr = JSON.stringify(currExperiment);
        var origExperimentStr = JSON.stringify(origCurrExperiment);
        // Compare the JSON strings to check for changes
        isDirty = currExperimentStr !== origExperimentStr;
        return isDirty;
    };
    UtilsService.prototype.getExperimentDefined = function (formatted) {
        var statusGot = formatted.status;
        var definedGot = 0;
        if (statusGot == "Backlog") {
            definedGot = 0;
        }
        else if (statusGot == "Completed") {
            definedGot = 100;
        }
        else if (statusGot == "In Plan") {
            var stDate = 'startDate' in formatted && formatted.startDate ? moment(new Date(formatted.startDate)) : undefined;
            if (stDate) {
                var dataNow = moment(new Date());
                var diff = moment.duration(dataNow.diff(stDate));
                // alert(stDate+ "---"+ dataNow+"---"+diff.weeks())
                var diffGot = diff.weeks();
                if (diffGot > 0) {
                    if (diffGot < formatted.duration) {
                        definedGot = Math.round((diffGot * 100) / formatted.duration);
                    }
                    else {
                        definedGot = 100;
                    }
                }
                else {
                    definedGot = 0;
                }
            }
            else {
                definedGot = 0;
            }
        }
        return definedGot;
    };
    UtilsService.prototype.getNpvSwing = function (display, npvData) {
        var item = npvData.find(function (n) { return n.name === display; });
        return item.npvSwing;
    };
    // Clamped Sticky Utils
    UtilsService.prototype.setStickyHeight = function (id, stickyIndex, note) {
        var ctrl = this;
        var el = document.getElementById(id + stickyIndex);
        if (!note.isHeightUpdated && el.scrollHeight) {
            ctrl.onTruncate(note, id + stickyIndex);
            note.isHeightUpdated = true;
        }
    };
    UtilsService.prototype.onMouseLeave = function (note, id, stickyIndex) {
        var ctrl = this;
        var title = document.getElementById(id + "-title" + stickyIndex);
        var content = document.getElementById(id + stickyIndex);
        if (title) {
            title.blur();
        }
        if (content) {
            content.blur();
        }
        note.isEditable = note.showFooter = false;
        ctrl.onTruncate(note, id + stickyIndex);
    };
    UtilsService.prototype.onEditNote = function (id, stickyIndex) {
        var title = document.getElementById(id + "-title" + stickyIndex);
        var content = document.getElementById(id + stickyIndex);
        if (title) {
            title.blur();
        }
        if (content) {
            content.blur();
        }
    };
    UtilsService.prototype.onExpandSticky = function (note, id, stickyIndex) {
        var ctrl = this;
        var stickyID = id + stickyIndex;
        var element = document.getElementById(stickyID);
        element.value = note.name;
        note.isEditable = true;
        ctrl.setFontSize(note, id, stickyIndex);
    };
    UtilsService.prototype.setFontSize = function (note, id, stickyIndex) {
        var ctrl = this;
        var stickyID = id + stickyIndex;
        var element = document.getElementById(stickyID);
        if (element != null) {
            ctrl.updateStickyHeight(note, element);
        }
    };
    UtilsService.prototype.onShowFooter = function (note, id, stickyIndex) {
        var ctrl = this;
        note.showFooter = true;
        ctrl.onExpandSticky(note, id, stickyIndex);
    };
    UtilsService.prototype.makeColor = function (colorNum) {
        var hues = [
            0, 20, 30, 40, 50, 60, 80, 120, 160, 190, 210, 230, 260, 290, 330, 360,
        ];
        //hues = [...Array(37).keys()].map(x=>x*10);
        var lights = [60, 50, 50, 50, 50, 50, 50, 55, 50, 55, 67, 77, 73, 67, 60, 60];
        var goldenFrac = 0.5 * (3 - Math.sqrt(5));
        var x = ((colorNum * goldenFrac) % 1.0) * (hues.length - 1);
        //x=colorNum%(hues.length-1); // for point visualisation
        var i = Math.floor(x);
        var f = x % 1.0;
        var hue = (1.0 - f) * hues[i] + f * hues[i + 1];
        var light = (1.0 - f) * lights[i] + f * lights[i + 1];
        return ("hsl( " +
            Math.round(hue * 100) / 100 +
            ", 100%, " +
            Math.round(light * 100) / 100 +
            "% )");
    };
    UtilsService.prototype.getRoundOff = function (number) {
        return Math.round((number) * 100) / 100;
    };
    UtilsService.prototype.onFteChange = function (currExperiment, fteGlobal, next) {
        var fteFactor = 0;
        currExperiment.totalCost = 0;
        fteGlobal.map(function (fte) {
            fteFactor += (Number(currExperiment.resFte[fte.Key] ? currExperiment.resFte[fte.Key] : 0) * fte['Val']);
        });
        var fteCost = fteFactor * (currExperiment.duration) / 52;
        var totalCost = this.getRoundOff(fteCost + currExperiment.cost);
        currExperiment.totalCost = totalCost;
        next();
    };
    UtilsService.prototype.handleRenderHandson = function (handsonTable) {
        var sidebarElements = document.querySelectorAll('.neat-layout-sidebar');
        // Use a ResizeObserver to detect changes in each sidebar's size
        var resizeObservers = [];
        // Function to handle the sidebar resize event
        function handleSidebarResize(entries) {
            // attachResizeObserverToChart();
            entries.forEach(function (entry) {
                // Trigger a Highchart redraw for each sidebar when it resizes
                try {
                    if (handsonTable) { // Assuming you have only one Highchart on the page
                        handsonTable.render();
                    }
                }
                catch (e) {
                }
            });
        }
        // Start observing each "neat-layout-sidebar" element
        sidebarElements.forEach(function (sidebarElement) {
            var resizeObserver = new ResizeObserver(handleSidebarResize);
            resizeObserver.observe(sidebarElement);
            resizeObservers.push(resizeObserver);
        });
        handsonTable.render();
    };
    UtilsService.prototype.updateStickyHeight = function (note, element) {
        var ctrl = this;
        element.style.height = "1px";
        var minHeight = 20 * ctrl.truncatedRowCount;
        var elHeight = element.scrollHeight > minHeight ? element.scrollHeight : minHeight;
        element.style.height = (3 + elHeight) + "px"; // 3 px for padding so 5px for adjustments
        var targetParentBlock = element.parentElement.parentElement.parentElement.parentElement;
        if (targetParentBlock.classList.contains("block") || targetParentBlock.classList.contains("centered-sticky")) {
            targetParentBlock.style.height = "1px";
            targetParentBlock.style.height = (30 + 25 + ctrl.heightCalibration + elHeight + (note.showFooter ? 30 : 0)) + "px";
        }
    };
    UtilsService.prototype.onTruncate = function (note, id) {
        var ctrl = this;
        note.isEditable = false;
        var element = document.getElementById(id);
        if (element != null) {
            var targetParentBlock = element.parentElement.parentElement.parentElement.parentElement;
            var rows = (element.scrollHeight - 3) / 20; // 3 px for padding for adjustments, 20px per line height
            var wordsPerRow = element.value.length / rows;
            element.style.height = (ctrl.truncatedRowCount * 20 + 3) + "px"; // 4 Lines
            if (element.value.length > (wordsPerRow * ctrl.truncatedRowCount)) {
                element.value = element.value.substring(0, (wordsPerRow * ctrl.truncatedRowCount) - 3) + "..."; // Truncate
            }
            if (targetParentBlock.classList.contains("block") || targetParentBlock.classList.contains("centered-sticky")) {
                targetParentBlock.style.height = "1px";
                targetParentBlock.style.height = (30 + 25 + ctrl.heightCalibration + element.scrollHeight) + "px";
            }
        }
    };
    UtilsService.prototype.onTruncateIgnorance = function (note, id) {
        var ctrl = this;
        note.isEditable = false;
        var element = document.getElementById(id);
        if (element != null) {
            var targetParentBlock = element.parentElement.parentElement.parentElement.parentElement;
            var rows = (element.scrollHeight - 3) / 20; // 3 px for padding for adjustments, 20px per line height
            var wordsPerRow = element.value.length / rows;
            element.style.height = (ctrl.truncatedRowCountIg * 20 + 3) + "px"; // 4 Lines
            var computedStyle = window.getComputedStyle(element);
            var fontSizeCurrent = computedStyle.fontSize;
            if (element.value.length > (wordsPerRow * ctrl.truncatedRowCountIg) && fontSizeCurrent != "10px") {
                // element.value = element.value.substring(0, (wordsPerRow * ctrl.truncatedRowCountIg) - 3) + "..."; // Truncate
                element.style.fontSize = "10px";
            }
            else if (element.value.length > (wordsPerRow * ctrl.truncatedRowCountIg)) {
                element.value = element.value.substring(0, (wordsPerRow * ctrl.truncatedRowCountIg) - 3) + "..."; // Truncate
            }
            else if (element.value.length < 24) {
                element.style.fontSize = "14px";
            }
            // if (targetParentBlock.classList.contains("block") || targetParentBlock.classList.contains("centered-sticky")) {
            //     targetParentBlock.style.height = "1px";
            //     targetParentBlock.style.height = (30 + 25 + ctrl.heightCalibration + element.scrollHeight) + "px";
            // }
        }
    };
    UtilsService.prototype.onTruncateImpact = function (note, id) {
        var ctrl = this;
        note.isEditable = false;
        var element = document.getElementById(id);
        if (element != null) {
            var targetParentBlock = element.parentElement.parentElement.parentElement.parentElement;
            var rows = (element.scrollHeight - 3) / 20; // 3 px for padding for adjustments, 20px per line height
            var wordsPerRow = element.value.length / rows;
            element.style.height = (ctrl.truncatedRowCountImpact * 20 + 3) + "px"; // 4 Lines
            var computedStyle = window.getComputedStyle(element);
            var fontSizeCurrent = computedStyle.fontSize;
            if (element.value.length > (wordsPerRow * ctrl.truncatedRowCountImpact) && fontSizeCurrent != "10px") {
                // element.value = element.value.substring(0, (wordsPerRow * ctrl.truncatedRowCountIg) - 3) + "..."; // Truncate
                element.style.fontSize = "10px";
                if (note.initialStyle == undefined) {
                    note.initialStyle = true;
                }
            }
            else if (element.value.length > (wordsPerRow * ctrl.truncatedRowCountImpact)) {
                element.value = element.value.substring(0, (wordsPerRow * ctrl.truncatedRowCountImpact) - 3) + "..."; // Truncate
            }
            else if (element.value.length < 24) {
                element.style.fontSize = "14px";
            }
        }
    };
    return UtilsService;
}());
exports.UtilsService = UtilsService;
// app.service('utilsService', UtilsService);
//# sourceMappingURL=inav-utils.service.js.map


// WEBPACK FOOTER //
// ./app/components/utils/inav-utils.service.js